import type { SchedulesHostHiddenFilter } from '@efficiently/client-api-schedules';
import type { NavigationPlaceKey } from '@efficiently/client-core-navigation';

import { SCHEDULES_NAVIGATION_PARAM_MAP } from '../../schedules-header/schedules-filters/constants/schedules-navigation-params.const';

/**
 * Returns `keys` without the keys whose `name` is the URL key of one of `hiddenFilters`, each hidden
 * filter resolved to its URL key through `SCHEDULES_NAVIGATION_PARAM_MAP`.
 *
 * @param keys The navigation-place keys to filter, in order.
 * @param hiddenFilters The filters whose URL keys are dropped.
 * @returns A new array holding the remaining keys in their original order; neither input is mutated.
 */
export function withoutHiddenFilterKeys(
	keys: readonly NavigationPlaceKey[],
	hiddenFilters: readonly SchedulesHostHiddenFilter[],
): readonly NavigationPlaceKey[] {
	const hiddenKeyNames = new Set<string>(hiddenFilters.map(filter => SCHEDULES_NAVIGATION_PARAM_MAP[filter]));

	return keys.filter(key => !hiddenKeyNames.has(key.name));
}
